// Admin-only preview of the subscription dunning banner: an admin picks a
// banner state on /admin/subscription-banners and the real banner renders on
// the home screen with the sample member below. Lives outside the admin page
// so SubscriptionBanner (in the main bundle) doesn't import a lazy admin page.

import type { DunningBannerInput, DunningMessageKey } from "@/lib/dunningBanner";

export type DunningPreviewData = Omit<DunningBannerInput, "platform" | "messageOverrides">;

export const DUNNING_PREVIEW_DATA: Record<DunningMessageKey, DunningPreviewData> = {
  past_due_soft: {
    subscriptionStatus: "past_due",
    subscriptionDeclineType: "soft",
    subscriptionRetryCount: 2,
    subscriptionMaxRetries: 4,
    subscriptionDaysRemaining: 12,
    subscriptionStatusUrl: "https://example.com/update-payment",
  },
  past_due_hard: {
    subscriptionStatus: "past_due",
    subscriptionDeclineType: "hard",
    subscriptionRetryCount: 4,
    subscriptionMaxRetries: 4,
    subscriptionDaysRemaining: 3,
    subscriptionStatusUrl: "https://example.com/update-payment",
  },
  on_hold: {
    subscriptionStatus: "on_hold",
    subscriptionStatusUrl: "https://example.com/update-payment",
  },
  pending_cancellation: {
    subscriptionStatus: "pending_cancellation",
    subscriptionDaysRemaining: 18,
    subscriptionStatusUrl: "https://example.com/resubscribe",
  },
};

const PREVIEW_KEY = "admin_banner_preview";

export function getActiveBannerPreview(): string | null {
  try { return localStorage.getItem(PREVIEW_KEY); } catch { return null; }
}

export function setActiveBannerPreview(key: DunningMessageKey) {
  try { localStorage.setItem(PREVIEW_KEY, key); } catch { /* localStorage may be unavailable */ }
}

export function clearBannerPreview() {
  try { localStorage.removeItem(PREVIEW_KEY); } catch { /* localStorage may be unavailable */ }
}

export function getBannerPreviewData(): DunningPreviewData | null {
  const key = getActiveBannerPreview();
  if (!key) return null;
  return DUNNING_PREVIEW_DATA[key as DunningMessageKey] ?? null;
}
